import {dpcGateway} from '@/config/env.uri'

export const uri = {
  dpcManage: {
    getByCard: `${dpcGateway}/setMeal/getMenuAndOrderByCard`,
    getTemporaryMenu: `${dpcGateway}/orderManager/getTemporaryOrderBycardNum`,
    get: `${dpcGateway}/dpc/getMeal`,
    add: `${dpcGateway}/orderManager/submitOrderBycardNum?cardNum=`,
    submitTemporaryOrderBycardNum: `${dpcGateway}/orderManager/submitTemporaryOrderBycardNum?cardNum=`,
    getOrderInfo: `${dpcGateway}/careWork/getOrderInfo`,
    getMemberInfo:`${dpcGateway}/memberInfo/getMemberInfoByCardNumber/`,
    getVerifyCard:`${dpcGateway}/memberInfo/verifyCardNumberBySms`,
    verifyCode:`${dpcGateway}/code/generate`,
    workerLogin:`${dpcGateway}/login`,
    getWorkerInfo:`${dpcGateway}/stationaryPoint/getStationaryPointById/`,
    queryCard:`${dpcGateway}/setMeal/getMenuAndOrderByCard`,
    getOrder:`${dpcGateway}/orderManager/getByMemberIdAndDate`,
    getImmediatelyOrder:`${dpcGateway}/timelyOrder/selectBySelective`,
    getByMemberIdAndDate:`${dpcGateway}/balanceHistory/getByMemberIdAndDate`,
    feedbackSave:`${dpcGateway}/userFeedback/save`,
    workerLogout:`${dpcGateway}/logout`,
    getDailyMenu:`${dpcGateway}/dailyStatement/getDailyStatementListBySelective`,
    getDailyMenuDetail:`${dpcGateway}/dailyStatement/newGetOrderListByDailySettlement`,
    deleteDailyMenuDetail:`${dpcGateway}/orderManager/deleteById/`,
    putDailyMenu:`${dpcGateway}/dailyStatement/preConfirm`,
    putOtherOrderManager:`${dpcGateway}/otherOrderManager`,
    putConfirm:`${dpcGateway}/dailyStatement/confirm`,
    getMyMenu:`${dpcGateway}/dailyStatement/getDiningOutByPage`,
    putMyConfirm:`${dpcGateway}/dailyStatement/postConfirm`,
    getStreet:`${dpcGateway}/dailyStatement/getStreetInfoListByPhone/`,
    batchOrderByDateAndPeriod:`${dpcGateway}/careWork/batchOrderByDateAndPeriod`,
    getCountByStreet:`${dpcGateway}/orderManager/getCountByStreet`,
    sysDict:`${dpcGateway}/dictionaryCategory/selectBySelectiveForCache`,//系统字典
    editSetMealBookType:`${dpcGateway}/memberInfo/editSetMealBookType`,
    selectByStationaryPointIdForTimely:`${dpcGateway}/stew/selectByStationaryPointIdForTimely/`,
    getTimelyOrderByPageAndCardNo:`${dpcGateway}/timelyOrder/getTimelyOrderByPageAndCardNo`,
    saveForTemporary:`${dpcGateway}/timelyOrder/saveForTemporary`,
    returnTemporaryOrderBycardNum:`${dpcGateway}/orderManager/returnTemporaryOrderBycardNum`,
    getCoupon:`${dpcGateway}/coupon/selectBySelective`,//优惠券
    weChatRecharge:`${dpcGateway}/weChatRecharge/native/createOrder`,//微信充值
    getPayResultByOutTradeNo:`${dpcGateway}/weChatRecharge/native/getPayResultByOutTradeNo/`,//充值成功
    getCouponByKeyWord:`${dpcGateway}/newCouponUsedRecord/selectByKeyWord`,//充值成功
  },
};



// WEBPACK FOOTER //
// ./src/api/uri/dpcUri/dpcManage.js